import React from "react";
import { Dialog, DialogContent, DialogTitle, Grid, List, ListItem, ListItemButton, ListItemText, Stack, TextareaAutosize, Typography } from "@mui/material";
import Service from "../../../../util/Service";
import SearchField from "../../../util/SearchField";


export default function ModelosJSDialog(props) {
    const { onClose, open } = props;
    const [code, setCode] = React.useState('');


    React.useEffect(() => {
        if (open) {
            // buscaAPI();
        }
    }, [open])

    const handleClose = () => {
        onClose();
    };

    function handleCarrega(modelo) {
        console.log(modelo);
        Service.FETCH("/api/bpmn/buscaCodigoExemplo/" + modelo).then(r => {            
            if (r && r.length > 0) {
                setCode(r);
            }
        }).catch(er => {
            console.log(er)
        });
    }
    return (
        <Dialog
            onClose={handleClose}
            maxWidth="xl"
            open={open}>
            <DialogTitle>
                Escolha um model
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={0}>
                    <Grid size="4">

                        <List sx={{
                            // width: '100%',
                            // maxWidth: 460,
                            // bgcolor: 'background.paper',
                            // position: 'relative',
                            // overflow: 'auto',
                            size:'small'
                            // maxHeight: 300,
                            // '& ul': { padding: 0 },
                        }}>
                            <ListItem disablePadding size="small">
                                <ListItemButton onClick={() => handleCarrega('carregaUserTask.html')}>
                                    <ListItemText primary="Carregar UserTask na pagina" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding size="small">
                                <ListItemButton onClick={() => handleCarrega('postBPMExample.html')}>
                                    <ListItemText primary="Post dados para processo BPM" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding size="small">
                                <ListItemButton onClick={() => handleCarrega('remontaMenuPrincipal.html')}>
                                    <ListItemText primary="Remonta menu principal" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid size="8">
                        <TextareaAutosize className="pd-code"
                            minRows={3}
                            maxRows={30}                            
                            // style={{ width: "600px", overflow: 'auto' }}
                            style={{ width: '800px', overflow: 'auto' }}
                            value={code}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}